import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import usePageTitle from '../hooks/usePageTitle';

const FoundersPage = () => {
  usePageTitle('Founders');
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <Header />

      <main id="main-content" tabIndex={-1} className="pt-32 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="mb-10"
          >
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-gray-500 hover:text-[#C8473A] mb-6 transition-colors"
              aria-label="Back to Home"
            >
              <ArrowLeft className="w-4 h-4" aria-hidden="true" />
              Back to Home
            </Link>
          </motion.div>

          {/* Text and image side by side, aligned */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 items-start"
          >
            <div className="lg:col-span-7">
              <h1 className="text-4xl md:text-5xl font-bold text-[#211F1F] mb-4">
                Challengineer <span className="text-[#C8473A]">Founders</span>
              </h1>
              <p className="text-lg text-gray-600 mb-6">
                As an early-stage VC fund, we have an enviable visibility to entrepreneurs who dare to dream, and execute disruptive ideas. People who leave their comfort zones and question the status quo; women and men with the spirit of enterprise and the courage to overcome any challenge by re-engineering their solutions, processes and people. In evaluating startups for investments, we actively search for this breed of founders who we call &apos;Challengineers&apos;.
              </p>
              <p className="text-gray-700 leading-relaxed prose prose-lg max-w-none">
                Since inception, our team of analysts have personally evaluated over 30,000 startups and yet, we have invested in just a handful of DeepTech and tech-enabled companies in each fund: that&apos;s because we go beyond the business idea or the executional ability of a team and peel away the layers until our partners are completely satisfied that the founding team can be nurtured to succeed.
              </p>
            </div>
            <div className="lg:col-span-5 flex justify-center lg:justify-end">
              <div className="w-full max-w-sm lg:max-w-[320px] bg-white rounded-3xl border border-gray-100 shadow-[0_2px_12px_-2px_rgba(0,0,0,0.08)] overflow-hidden p-2">
                <img
                  src="/images/challengineer-infographic.png?v=20260224b"
                  alt="Challengineer - See like a child, Create like a god, Rule like a lion, Win like a soldier"
                  className="w-full h-auto object-contain rounded-2xl block"
                />
              </div>
            </div>
          </motion.div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default FoundersPage;
